<template>
  <div 
    class="hero-background">
    <img
      :src="srcSetImages['1440']"
      :srcset="srcSet"
      class="hero-background__img">
  </div>
</template>

<script>
export default {
  name: 'HeroBackground',
  data: () => ({
    lazyLoading: require('@/assets/lazy/home-background-slider.png')
  }),
  props: {
    srcSetImages: {
      type: Object,
      required: true
    }
  },
  computed: {
    srcSet: {
      get () {
        return Object.keys(this.srcSetImages)
          .map(width => parseInt(width, 10))
          .sort((a, b) => a - b)
          .reduce((srcSet, width) => `${srcSet} ${this.srcSetImages[width]} ${width}w,`, '')
          .slice(0, -1)
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./background.scss";
</style>
